import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gus-circle-close-icon',
  standalone: true,
  templateUrl: './circle-close-icon.component.html',
  styleUrl: './circle-close-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircleCloseIconComponent {}
